import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from '../configs/AppConfig';

const HelpService = {};

HelpService.getHelp = function (params) {
  const page = params || 1;
  const offset = (page - 1) * 10;
  return fetch({
    url: API_BASE_URL + '/v1/admin/get-help',
    method: 'get',
    params: {
      offset,
    },
  });
};

HelpService.resolveHelp = function (data) {
  return fetch({
    url: API_BASE_URL + '/v1/admin/update-help',
    method: 'put',
    data,
  });
};

export default HelpService;
